/*
 * @Author: jsZhao
 * @Date: 2018-02-05 11:51:43
 * @Last Modified by: jsZhao
 * @Last Modified time: 2018-02-05 16:14:43
 * 园区管理 API
 */

import fetch from '@/utils/fetch';
import {shop_url} from '@/global';

const GET_CIRCLE_REPORT = `${shop_url}/shop/cms/moments/`
const DEL_CIRCLE = `${shop_url}/shop/cms/moments/`

/*
  分页查询反馈列表
  status: 0查询所有，1未处理，2已忽略，3已反馈
*/
const feedbackList = ({username,status,currentPage,pageSize=10}={})=>{
  let url = `${shop_url}/shop/cms/feedback/?page=${currentPage}&rows=${pageSize}`;
  if(username != undefined||status != undefined){ url = `${shop_url}/shop/cms/feedback/?page=${currentPage}&rows=${pageSize}&username=${username}&status=${status}`}

  const method = 'get';
  return fetch({
    url,
    method,
  })
}

/*
  根据id忽略反馈
  id: 反馈id
*/

const feedbackIgnore = (id)=>{
  const url = `${shop_url}/shop/cms/feedback/`
  const method = 'patch'
  const data ={
    id: id
  }
  return fetch({
    url,
    data,
    method
  })
}

/*
  根据id回复反馈
  id：反馈id，content：反馈内容
*/

const feedbackReply = (id,content)=>{
  const url = `${shop_url}/shop/cms/feedback/`
  const method = 'put'
  const data ={
    id: id,
    content: content
  }
  return fetch({
    url,
    data,
    method
  })
}

const getCircleReport = (name,page,pageCount)=>{
  return fetch({
    url:GET_CIRCLE_REPORT+page+"/"+pageCount+"?name="+name,
    method:'get'
  })
}

const delCircle = (id)=>{
  return fetch({
    url:DEL_CIRCLE+id,
    method:'delete'
  })
}

export {
  feedbackList,
  feedbackIgnore,
  feedbackReply,
  getCircleReport,
  delCircle
}



// WEBPACK FOOTER //
// ./src/api/parkManage/index.js